export const EDIT_ADMIN_REQUEST = "EDIT_ADMIN_REQUEST";
export const EDIT_ADMIN_RECEIVE = "EDIT_ADMIN_RECEIVE";
export const EDIT_ADMIN_FAILURE = "EDIT_ADMIN_FAILURE";
export const RESET_EDIT_ADMIN = "RESET_EDIT_ADMIN";
